export function getCookie(cookieName: string) {
  const cookie = {};
  document.cookie.split(';').forEach(function (el) {
    const [key, value] = el.split('=');
    cookie[key.trim() as keyof typeof cookie] = value as never;
  });
  return cookie[cookieName as keyof typeof cookie];
}
